<template>
    <div
        :class='["uploadArea", {small: small, draggingOver: draggingOver}]'
        :inline="inline"
        @dragover.prevent="() => {draggingOver = true}"
        @dragleave.prevent="() => {draggingOver = false}"
        @dragenter.prevent="() => {}"
        @drop.prevent="(e) => {drop(e)}"
    >
        <slot>

        </slot>
    </div>
</template>

<script>
    export default {
        name: 'UploadInvisible',
        props: ['inline', 'small', 'single', 'multi', 'extensions'],
        data () {
            return {
                draggingOver: false
            }
        },
        methods: {
            drop (e) {
                const files = [...e.dataTransfer.files]
                const filteredFiles = this.filterByExtensions(files)

                if (this.single) {
                    if (filteredFiles.length > 0) {
                        this.uploadSingle(filteredFiles[0])
                    }
                } else {
                    filteredFiles.reduce((prom, file) => {
                        return prom.then(() => {
                            return this.uploadSingle(file)
                        })
                    }, Promise.resolve([]))

                }
            },
            uploadSingle (file) {
                return this.$store.dispatch('uploadFile', {
                    file,
                }).then((response) => {
                    this.$emit('uploaded', response)
                }).catch((error) => {
                    this.$emit('error', error)
                })

            },
            filterByExtensions (files) {
                if ((this.extensions || []).length > 0) {
                    const lowcaseExtensions = this.extensions.map(e => e.toLowerCase())

                    return files.filter(file => {
                        return lowcaseExtensions.filter(ext => {
                            return file.name.toLowerCase().endsWith(ext)
                        }).length > 0
                    })
                } else {
                    return files
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .uploadArea {
        height: 100%;
        width: 100%;

        &.small {
            height: initial;
            width: initial;
        }

        &.draggingOver {
            border-color: red;
            border-width: 3px;
        }

        span {
            text-align: center;
        }
    }
</style>